'use client';

import Link from 'next/link';
import { FileQuestion } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <FileQuestion className="h-24 w-24 text-muted-foreground" />
      <div className="space-y-2">
        <h1 className="text-4xl font-bold">404</h1>
        <h2 className="text-xl font-medium text-muted-foreground">
          Página não encontrada
        </h2>
        <p className="text-sm text-muted-foreground">
          A página que você está procurando não existe ou foi movida.
        </p>
      </div>
      <Link href="/" className={buttonVariants()}>
        Voltar ao início
      </Link>
    </div>
  );
}
